import React, { useEffect, useState } from 'react';
import { ConfirmProvider } from 'material-ui-confirm';
import { injectIntl } from 'react-intl';
import DOMPurify from 'dompurify';
import KpiSrcEdit from './KpiSrcEdit';
import { Link } from 'react-router-dom';
import './KpiWidget.scss';

// Safe renderer: sanitizes source HTML rather than executing it as JSX.
// react-live was removed (UT-XSS-01): it executed arbitrary server-fetched JSX code,
// which is a critical RCE vulnerability if KPI widget data is compromised.
const SafeKpiRenderer = ({ sourceCode }) => (
  <div
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sourceCode ?? '') }}
  />
);

const KpiWidget = ({ kpiInfo, userName, editable, intl, deleteKpi, isNew = false }) => {

  const [kpiSrc, setKpiSrc] = useState(kpiInfo.source);
  const scope = { useEffect, useState, Link, userName, intl, cardDomId: kpiInfo.sourceLocation };
  const handleEnter = e => {
    if (e) {
      if (e.keyCode === 13) {
        if (
          e.target &&
          e.target.getElementsByTagName('a') &&
          e.target.getElementsByTagName('a').length > 0
        ) {
          const loc = e.target.getElementsByTagName('a')[0].href;
          e.preventDefault();
          window.location.href = loc;
        }
      }
    }
  };

  useEffect(() => {
    if (kpiInfo && kpiInfo.name) {
      if (document.getElementById(kpiInfo.name)) {
        if (
          document.getElementById(kpiInfo.name).getElementsByTagName('a') &&
          document.getElementById(kpiInfo.name).getElementsByTagName('a').length > 0
        ) {
          document.getElementById(kpiInfo.name).getElementsByTagName('a')[0].tabIndex = -1;
          document.getElementById(kpiInfo.name).addEventListener('keypress', handleEnter);
        }
      }
    }
  }, [kpiInfo]);

  if (!isNew) return (
    <div className={`requestAction-Tiles`} id={kpiInfo.name} tabIndex="0">
      <div className={editable ? 'mt-3' : 'm-auto'}>
        <SafeKpiRenderer sourceCode={kpiSrc} />
      </div>
      {editable && (
        <ConfirmProvider>
          <KpiSrcEdit
            kpiInfo={kpiInfo}
            setCodeStr={setKpiSrc}
            scopeObj={scope}
            isNew={false}
            deleteKpi={deleteKpi}
          />
        </ConfirmProvider>
      )}
    </div>
  );
  else return null;

};

export default injectIntl(KpiWidget);
